import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';
import type { TopicSitemapPageDataErrorCode } from './types';

export const {
	Context: TopicSitemapPageDataContext,
	Provider: TopicSitemapPageDataContextProvider,
	useContext: useTopicSitemapPageData,
	useAsyncData: useTopicSitemapPageDataFromApi,
	prefetchAsyncData: prefetchTopicSitemapPageDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'TopicSitemapPageDataContext',
	dataProperty: 'pageData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: ({ startsWith }) => startsWith || '',
	hookDeps: ({ startsWith }) => [startsWith],
	errorHandler: pageDataErrorHandler<TopicSitemapPageDataErrorCode>(),
});
